var exports = {
  "pz": "RecentMentionsContent.module__filterButton___N2FpNF",
  "Pt": "RecentMentionsContent.module__filterButtonActive___N2FpNF",
  "XG": "RecentMentionsContent.module__scroller___N2FpNF",
  "bm": "RecentMentionsContent.module__guildGroup___N2FpNF",
  "W1": "RecentMentionsContent.module__messageCard___N2FpNF",
  "v0": "RecentMentionsContent.module__iconMedium___N2FpNF",
};

module.exports = exports;
